import * as ActionTypes from './actionTypes'

import _ from 'lodash'
import {
  saveLineItemAIInfo,
  saveLineItemSummaryInfo
} from "../api/saveC88Data";



export function saveLineItemAIInfoFeild(invoiceIndex, index, infoIndex, fieldName) {
  return (dispatch, getState) => {
    let lineItem = getState().InvoicesReducer.invoices[invoiceIndex].merchandiseList[index]
    let lineItemInfo = lineItem.aiStatementUkInfo[infoIndex]
    let response = saveLineItemAIInfo(lineItem.merchandiseId, lineItemInfo.infoId, fieldName, lineItemInfo[fieldName] === "" ? "_BLANK_" : lineItemInfo[fieldName]);
    console.log(response)
  }
}


export function saveLineItemSummary(invoiceIndex, index, infoIndex, fieldName) {
  return (dispatch, getState) => {
    let lineItem = getState().InvoicesReducer.invoices[invoiceIndex].merchandiseList[index]
    let lineItemInfo = lineItem.previousDocumentInfo[infoIndex]
    let response = saveLineItemSummaryInfo(lineItem.merchandiseId, lineItemInfo.infoId, fieldName, lineItemInfo[fieldName] === "" ? "_BLANK_" : lineItemInfo[fieldName]);
    console.log(response)
  }
}



export const updateInvoiceHeaderFieldValue = (payload) => {
  return {
    type: ActionTypes.UPDATE_INVOICE_HEADER_VALUE,
    payload
  }
}